









import Vue from "vue";
import { getStorageSync, delStorageSync } from "./unitl/common";
import { constant } from "./unitl/constant";
import { PostLogout } from "./server";
// import HelloWorld from "./components/HelloWorld.vue";

export default Vue.extend({
    name: "App",
    components: {},
    data() {
        const userInfo =getStorageSync(constant.userInfo) || '{ "nickname": "" }';
        return {
            userInfo: JSON.parse(userInfo),
			htmlCanvasAdjust:15
        };
    },
    methods: {
        quit() {
            PostLogout().then(() => {
                this.$router.replace({ name: "Home" });
                delStorageSync(constant.token);
                delStorageSync(constant.userInfo);
                window.location.reload();
            });
        }
    }
});
